import LocationName from './components/LocationName'
import LocationSelect from './components/LocationSelect'

export { LocationName, LocationSelect }
